import { z } from "zod/v4";

import { OrganizationSummaryDtoSchema } from "../../../dtos/organization-summaries";

export const GetOrganizationSummaryResponseBodySchema = z.object({
  org: OrganizationSummaryDtoSchema,
});

export type GetOrganizationSummaryResponseBodyType = z.infer<
  typeof GetOrganizationSummaryResponseBodySchema
>;
